module.exports = __webpack_public_path__ + "img/zvs-overview.ecd644a7.jpg";